module.exports = __webpack_public_path__ + "static/media/ic_white_left_arrow.a86bf6c8.svg";